import React from "react";
import { Link } from "react-router-dom";
import { 
  MapPin, Phone, Mail, Facebook, Twitter, Instagram, Linkedin 
} from "lucide-react";
import { LOGO_URL, COMPANY } from "../lib/brand";

export default function Footer() {
  return (
    <footer className="bg-[#131A26] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="inline-flex items-center justify-center h-14 px-4 py-2 rounded-xl bg-white mb-6">
              <img src={LOGO_URL} alt="ALearn India" className="h-full w-auto object-contain" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-8">
              Transform Your Life Through Education. Where students meet teachers around the world online.
            </p>
            <div className="flex space-x-4">
              {[Facebook, Twitter, Instagram, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#FFC107] transition">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/courses" className="hover:text-white">All Courses</Link></li>
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/login" className="hover:text-white">Student Portal</Link></li>
              <li><Link to="/login" className="hover:text-white">Admin Dashboard</Link></li>
            </ul>
          </div>

          {/* Top Categories */}
          <div>
            <h4 className="text-lg font-bold mb-6">Top Categories</h4>
            <ul className="space-y-4 text-sm text-gray-400">
              <li><Link to="/courses" className="hover:text-white">Language Courses</Link></li>
              <li><Link to="/courses" className="hover:text-white">Academic Courses</Link></li>
              <li><Link to="/courses" className="hover:text-white">Skill Development</Link></li>
              <li><Link to="/courses" className="hover:text-white">Study Abroad</Link></li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contact Us</h4>
            <ul className="space-y-6 text-sm text-gray-400">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 text-[#FFC107] mr-3 shrink-0" />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 text-[#FFC107] mr-3 shrink-0" />
                <a href={`tel:${COMPANY.phoneTel}`}>{COMPANY.phone}</a>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 text-[#FFC107] mr-3 shrink-0" />
                <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} Alearn India. All rights reserved.</p>
          <div className="flex gap-8">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
